export default function () {
  return {
    fromPage: '',
    flowType: '',
    token: undefined,
    verificationReceiver: undefined,
    isVerificationCodeNeeded: undefined,
    rememberMe: false,
    verificationInfo: {
      hasEmailAddress: undefined,
      hasPhoneNumber: undefined,
    },
    email: '',
    accountDetails: undefined,
    hasIdinFailed: false,
    idinFailureMessage: '',
    hasIdinFailureInstructions: false,
    isLoggingOff: false,
    idinBankOptions: {},
    bankOptions: [],
  };
}
